import { useUserProfile } from '@/hooks/useUserProfile';
import { useAuth } from '@/contexts/AuthContext';
import { getAvatarColor } from '@/lib/avatar-color';
import { cn } from '@/lib/utils';

interface UserAvatarProps {
  size?: number;
  className?: string;
}

const UserAvatar = ({ size = 36, className }: UserAvatarProps) => {
  const { user } = useAuth();
  const { profile } = useUserProfile();
  if (!user) return null;

  const initial = (user.email || 'U').trim().charAt(0).toUpperCase();
  const bg = getAvatarColor(user.id || user.email || 'x');
  const dim = { width: size, height: size };

  const auraStyle = { boxShadow: '0 0 0 2px hsl(var(--primary) / 0.65), 0 0 12px 1px hsl(var(--primary) / 0.45)' };

  if (profile?.avatar_url) {
    return (
      <img
        src={profile.avatar_url}
        alt="Account"
        style={{ ...dim, ...auraStyle }}
        className={cn('rounded-full object-cover', className)}
      />
    );
  }

  return (
    <div
      style={{ ...dim, backgroundColor: bg, ...auraStyle }}
      className={cn(
        'flex items-center justify-center rounded-full font-display text-sm font-semibold text-white select-none',
        className,
      )}
      aria-label="Account"
    >
      {initial}
    </div>
  );
};

export default UserAvatar;
